var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-3",attrs:{"disabled":_vm.disabled,"color":"primary"},on:{"click":_vm.renderDoc}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" mdi-file-word-box-outline ")])],1)]}}])},[_vm._v(" lade eine Datei (.docx) eines"),_c('br'),_vm._v(" Schülerzeugnis herunter. ")])}
var staticRenderFns = []

export { render, staticRenderFns }